import React from 'react';
import classNames from 'classnames';
import app from 'general/js/app';
import LeaderboardCellPlayerBasic from './leaderboard-cell-player-basic.js';
import LeaderboardCellPlayerLeaders from './leaderboard-cell-player-leaders.js';
import { viewTypes } from '../enums';

const LeaderboardCellPlayer = (
    {
        player,
        view,
        isChampion,
        isPlayOff,
        isEnhanced,
        liveScanner,
        ...rest
    }
) => {
    let playOffHoles = null;
    const playOffRoundId = liveScanner.liveComponents.leaderboard !== undefined ? liveScanner.liveComponents.leaderboard.playoffRoundId : 401;

    if (Array.isArray(player.rounds)) {
        playOffHoles = player.rounds.find((round) => round.id === playOffRoundId);
    }

    const renderPlayOffView = () => {
        if (!isPlayOff || isChampion) return false;

        return playOffHoles && playOffHoles.length > 6;
    };

    const getIsChampionPlayOff = () => {
        return isChampion &&
            view !== viewTypes.HOLE_BY_HOLE &&
            playOffHoles &&
            playOffHoles.length > 6;
    };

    const renderPlayerContent = () => {
        if (isEnhanced && view !== viewTypes.HOLE_BY_HOLE) {
            return (
                <LeaderboardCellPlayerLeaders
                    {...rest}
                    view={view}
                    player={player}
                    isPlayOff={isPlayOff}
                    liveScanner={liveScanner}
                />
            );
        }

        return (
            <LeaderboardCellPlayerBasic
                {...rest}
                view={view}
                player={player}
                isPlayOff={isPlayOff}
            />
        );
    };

    const renderChampionStatus = () => {
        if (!isChampion || view === viewTypes.HOLE_BY_HOLE) return null;

        return (
            <h3 className="leaderboard__cell-player-leaders-champion">
                <div className="leaderboard__cell-champion-short-text">{app.state.championLabels.mobile}</div>
                <div className="leaderboard__cell-champion-long-text">
                    <div>{app.state.championLabels.desktop}</div>
                </div>
            </h3>
        );
    };

    const cellStateCss = classNames({
        'is-leaders': view !== viewTypes.HOLE_BY_HOLE && isEnhanced,
        'is-play-off': isPlayOff && view !== viewTypes.HOLE_BY_HOLE,
        'is-play-off-res': renderPlayOffView(),
        'is-champion': isChampion,
        'is-champion-play-off': getIsChampionPlayOff()
    });

    return (
        <div className={`leaderboard__cell leaderboard__cell--player ${cellStateCss}`}>
            <div className="leaderboard__cell-content">
                {renderChampionStatus()}
                <div className="leaderboard__cell-player">
                    {renderPlayerContent()}
                </div>
            </div>
        </div>
    );
};

export default LeaderboardCellPlayer;
